<template>
  <div :key="key.tablero">
    <div
      id="cargando"
      wire:loading
      class="
        fixed
        top-0
        left-0
        right-0
        bottom-0
        w-full
        h-screen
        z-50
        overflow-hidden
        bg-gray-700
        opacity-75
        flex flex-col
        items-center
        justify-center
      "
    >
      <div
        class="
          loader
          ease-linear
          rounded-full
          border-4 border-t-4
          h-12
          w-12
          mb-4
        "
      ></div>
      <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
      <p class="w-1/3 text-center text-white">
        Esto puede tardar unos segundos, no cierre esta página.
      </p>
    </div>
    <div class="flex" style="margin-top: 60px">
        <div id="create">
            <v-speed-dial v-model="fab"
                          :top="top"
                          :bottom="bottom"
                          :right="right"
                          :left="left"
                          :direction="direction"
                          :open-on-hover="hover"
                          :transition="transition">
                <template v-slot:activator>
                    <v-btn v-model="fab"
                           color="primary"
                           dark
                           fab
                           class="flotantebtn">
                        <v-icon v-if="fab">
                            mdi-close
                        </v-icon>
                        <v-icon v-else>
                            mdi-apps
                        </v-icon>
                    </v-btn>

                </template>
                <JsonExcel class="btn"
                           :fetch="fetchData"
                           :name="`${nombreArchivo}.xls`">
                    <v-btn fab
                           title="Descargar Excel"
                           dark
                           small
                           color="green"
                           class="flotantebtnmenu">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                </JsonExcel>
            </v-speed-dial>
        </div>
        <v-chip small
                :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'"
                label>
            <v-icon left>
                mdi-database
            </v-icon>Total: {{ this.Total }}
        </v-chip>
        <v-chip small
                :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'"
                label>{{ this.seccion }}</v-chip>
        <v-chip small
                :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'"
                label>{{ this.PTabNombre }}</v-chip>


    </div>
  <div  class="flex justify-center">
      <!--<div class="min-h-screen flex  py-12">-->
    <!-- <div  class="sticky justify-center">
      <div  class="div" style="margin-top: 60px"> -->
      
      <!--</div>-->
      <div  v-dragscroll="scroll" class="min-h-screen flex overflow-x-scroll py-2">
        <!-- <div v-for="columna in tablero" :key="columna.encabezado" class="bg-gray-100 md:container xl:mx-auto lg:mx-auto md:mx-auto sm:mx-auto px-2 py-3 rounded rounded-lg" > -->
        <div
          v-for="columna in tablero"
          :key="columna.encabezado"
          :class="{ 'bg-gray-900': theme, 'bg-gray-200': !theme }"
          class="md:container m-0.5 px-2 py-2 rounded rounded-lg"
        >
          <p
            class="text-gray-400 font-semibold font-sans tracking-wide text-sm"
          >
            {{ columna.encabezado }}
            <v-chip
              v-if="obtenerTotal(columna.idColumna) != 0"
              small
              :style="bgStyle([83, 103, 254])"
              :class="'primaryConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'"
              label
              >{{ obtenerTotal(columna.idColumna) }}</v-chip
            >
          </p>

          <!-- Draggable component comes from vuedraggable. It provides drag & drop functionality -->
          <!-- <draggable :list="columna.tarjeta" :animation="200" ghost-class="ghost-card" group="tasks"> -->
          <!-- Each element from here will be draggable and animated. Note :key is very important here to be unique both for draggable and animations to be smooth & consistent. -->
          <task-card
            v-for="tarjeta in columna.tarjeta"
            :key="tarjeta.ClaveTar"
            :tarjeta="tarjeta"
            class="mt-3 cursor-move"
          ></task-card>
          <!-- </transition-group> -->
          <!-- </draggable> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import draggable from "vuedraggable";
import TaskCard from "@/components/pages/operacion/tablero/Tarjeta.vue";
import { dragscroll } from "vue-dragscroll";
import JsonExcel from 'vue-json-excel';

export default {
  props: ["busqueda"],
  components: {
    TaskCard,
    draggable,
    JsonExcel
  },
  directives: {
    dragscroll,
  },
  data() {
    return {
      columnas: [],
      tarjetas: [],
      numTarjetas: [],
      tablero: [],
      scroll:true,
      Total: 0,
      proceso: 0,
      PTabNombre: '',
      relevancia: '',
      aiclave: '',
        seccion: '',

        direction: 'top',
        fab: false,
        fling: false,
        hover: false,
        tabs: null,
        top: true,
        right: true,
        bottom: false,
        left: false,
        transition: 'scale',

        listadoExcel: [],
        nombreArchivo: `ReportesTablero_${this.$moment().format("YYYY-MM-DD")}`
    };
  },
  computed: {
    ...mapState(["domain", "theme"]),
    ...mapState("Operacion", ["key"]),
  },

  methods: {
      async fetchData() {
          const response = this.listadoExcel;
          return response;

      },
      async obtenerReportesExcel() {
          var formData = new FormData();
          formData.append("proceso", this.proceso);
          formData.append("relevancia", this.relevancia);
          formData.append("aiclave", this.aiclave);
          let response = await this.axios.post(
              `${this.domain.domainNameForApi}Tablero/descargarExcel`,
              formData
          );
          this.listadoExcel = response.data;
      },
    async obtenerColumnas() {
      var formData = new FormData();
      formData.append("proceso", this.proceso);
      let response = await this.axios.post(
        `${this.domain.domainNameForApi}Tablero/Encabezado`,
        formData
      );
      this.columnas = response.data.sort((a, b) => a.Orden - b.Orden);
    },
    async obtenerTarjetas() {
      var formData = new FormData();
        formData.append("proceso", this.proceso);
        formData.append("relevancia", this.relevancia);
        formData.append("aiclave", this.aiclave);
      let response = await this.axios.post(
        `${this.domain.domainNameForApi}Tablero/Tarjetas`,
        formData
      );
      this.tarjetas = response.data;
    },
     async obtenerTotalTarjetas() {
      var formData = new FormData();
         formData.append("proceso", this.proceso);
         formData.append("relevancia", this.relevancia);
         formData.append("aiclave", this.aiclave);
      let response = await this.axios.post(
        `${this.domain.domainNameForApi}Tablero/TotalTarjetas`,
        formData
      );
      this.numTarjetas = response.data;
      let sum = 0;
      //this.Total= response.data.reduce((sum, item) => sum + item.Total, 0);
         for (let i in response.data) {
             if (response.data[i].ClaveCol != 78) {
                 this.Total += response.data[i].Total;
             }
         }
    },
    obtenerTotal(id) {
      var find = this.numTarjetas.filter((item) => item.ClaveCol == id);
      return find.length == 0 ? 0 : find[0].Total;
    },
    bgStyle: function (color) {
      const [r, g, b] = color;
      return {
        backgroundColor: `rgba(${r},${g},${b}, 0.2)`,
      };
    },
  },
  async mounted() {
      this.proceso = this.$route.params.proceso;
      this.seccion = this.$route.params.seccion;
      this.PTabNombre = this.$route.params.PTabNombre;
      this.relevancia = this.$route.params.relevancia;
      this.aiclave = this.$route.params.aiclave;
            //console.log(this.aiclave);


      if (this.proceso === undefined) {
          this.$router.push({ name: 'index' });
      }
      else {
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              this.scroll = false;
          } else {
              this.scroll = true;
          }
          await this.obtenerReportesExcel();
          await this.obtenerColumnas();
          await this.obtenerTarjetas();
          await this.obtenerTotalTarjetas();
          this.columnas.forEach((element) => {
              this.tablero.push({
                  idColumna: element.ClaveCol,
                  encabezado: element.Titulo,
                  tarjeta: this.tarjetas.filter(
                      (item) => item.ClaveCol == element.ClaveCol
                  ),
              });
          });
          if (this.columnas.length == this.tablero.length) {
              setTimeout(() => {
                  document.getElementById("cargando").style.opacity = 0;
                  setTimeout(() => {
                      document.getElementById("cargando").style.display = "none";
                  }, 2000);
              }, 1000);
          }
      }

  },
};
</script>

<style>
    /* This is for documentation purposes and will not be needed in your application */
    #create .v-speed-dial {
        position: absolute;
    }

    #create .v-btn--floating {
        position: relative;
    }
</style>

<style lang="scss">
    #create .v-btn {
        position: fixed;
    }
    .flotantebtn {
        top: 500px;
        position: fixed;
        right: 10px;
    }

    .flotantebtnmenu {
        top: 440px;
        position: fixed;
        right: 10px;
    }
.column-width {
  min-width: 320px;
  width: 320px;
}
/* Unfortunately @apply cannot be setup in codesandbox, 
but you'd use "@apply border opacity-50 border-blue-500 bg-gray-200" here */
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}

//Loading
.loader {
  border-top-color: #3498db;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.opacity-75 {
  transition: opacity 2s linear;
  width: 40px;
  height: 40px;
  opacity: 0.75;
}
</style>
